import { Link } from "react-router-dom";
import { animeCategories } from "@/mocks/anime";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-50 border-t border-primary-100 mt-16">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-flower-fill"></i>
              </span>
              <span className="font-brand text-xl text-foreground-950">樱花动漫在线</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed max-w-md">
              樱花动漫在线是一个专注于动漫内容展示与在线播放体验的二次元门户，覆盖热门新番与经典动画，
              为动漫爱好者提供便捷的分类浏览、精准筛选与相关推荐服务。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950 mb-3">快速导航</h3>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-700 hover:text-primary-700 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-foreground-700 hover:text-primary-700 cursor-pointer">
                  动漫分类
                </Link>
              </li>
              <li>
                <Link to="/topic" className="text-foreground-700 hover:text-primary-700 cursor-pointer">
                  专题合集
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-700 hover:text-primary-700 cursor-pointer">
                  搜索动漫
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-700 hover:text-primary-700 cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950 mb-3">热门分类</h3>
            <div className="flex flex-wrap gap-2">
              {animeCategories.slice(0, 8).map((c) => (
                <Link
                  key={c}
                  to={`/category?category=${encodeURIComponent(c)}`}
                  className="px-2.5 py-1 rounded-full bg-background-50 border border-primary-200 text-xs text-foreground-700 hover:text-primary-700 hover:border-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {c}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600 leading-relaxed">
            © 2026 樱花动漫在线 · 本站所有内容均为演示用途，不提供真实视频播放服务。
          </p>
          <p className="text-xs text-foreground-600 whitespace-nowrap">
            友情提示：请支持正版资源，合理追番
          </p>
        </div>
      </div>
    </footer>
  );
}